import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { urls } from "../../../urls";
import { getCatchError } from '../../../getCatchError';

const setPostUpdateStatus = (params, setError) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_STATUS_UPDATE_WITHDRAWAL
            });
            dispatch(Action.SetGetWithdrawalsAwaiting({
                page: 1,
                rowsPerPage: 10
            }))
        } catch (error) {
            getCatchError(error, setError)
        }
    }
}

export {
    setPostUpdateStatus as SetPostUpdateStatus
}